import React, { useState } from 'react';
import Switch from 'components/UI/Switch';
import { Modal } from '../../../common';
import { Button, ButtonRow } from 'common';
import { useDispatch, useSelector } from 'react-redux';
import { setDeliverySms } from 'actions/PersonalInfo';
export const B2BModeToggle = ({}) => {
    const dispatch = useDispatch();
    const [internalToggleState, setInternalToggleState] = useState({
        showStoreSwitchModal: false,
        pendingB2BToggleValue: null,
    });
    const isB2BModeEnabled = useSelector((state) => state.ui.isB2BModeEnabled);
    const isB2BModeAvailable = useSelector((state) => state.personalInfo.b2bCustomer);
    const cartSize = useSelector((state) => state.cart.products.length);
    const applyB2BToggle = (value) => {
        const b2bModeEnabled = value;
        dispatch({ type: 'TOGGLE_B2B_MODE', payload: b2bModeEnabled });
        // There is a different set of products between B2C and B2B stores so any stored product needs to be cleared.
        dispatch({ type: 'CLEAR_CART' });
        dispatch({ type: 'CLEAR_CHECKOUT_B2B_B2C_STORE_CHANGE' });
        // If B2C users started to access parts of the page related to subscription orders we need to reset those to base state
        // to not present them with confusing information in the UI
        dispatch({ type: 'RESET_SUBSCRIPTION_STATE' });
        const shouldSendSMSForOrder = !b2bModeEnabled;
        // When B2B mode is enabled we want to disable SMS delivery for the order sender since they will receive it for all order lines.
        // For big orders the amount of SMS messages can be overwhelming.
        dispatch(setDeliverySms(shouldSendSMSForOrder));
    };
    const onToggleChange = (value) => {
        if (cartSize > 0) {
            setInternalToggleState({ showStoreSwitchModal: true, pendingB2BToggleValue: value });
        }
        else {
            applyB2BToggle(value);
        }
    };
    const handleProceedModal = () => {
        if (internalToggleState.pendingB2BToggleValue !== null) {
            applyB2BToggle(internalToggleState.pendingB2BToggleValue);
        }
        setInternalToggleState({ showStoreSwitchModal: false, pendingB2BToggleValue: null });
    };
    const handleCancelModal = () => {
        setInternalToggleState({ showStoreSwitchModal: false, pendingB2BToggleValue: null });
    };
    return (React.createElement(React.Fragment, null,
        isB2BModeAvailable && (React.createElement("div", { className: "user-navigation__switch-bar" },
            React.createElement("span", { className: "user-navigation__switch-label" }, "Bedrift"),
            React.createElement(Switch, { on: isB2BModeEnabled, onChange: onToggleChange }))),
        internalToggleState.showStoreSwitchModal && (React.createElement(Modal, { onClose: handleCancelModal, className: "user-navigation__b2b-modal", labelId: "b2bModalLabel" },
            React.createElement("h2", { id: "b2bModalLabel" }, "Du har varer i handlekurven din"),
            React.createElement("p", null, "Innholdet i handlekurven slettes n\u00E5r du bytter mellom bedrift og privat."),
            React.createElement(ButtonRow, { display: "center" },
                React.createElement(Button, { type: "action", style: "ghost", onClick: handleCancelModal }, "Avbryt"),
                React.createElement(Button, { type: "action", style: "primary", onClick: handleProceedModal }, "Fortsett"))))));
};
